// extracted by mini-css-extract-plugin
export default {"image":"bZ-z","loaded":"cZ-z"};